import { render, staticRenderFns } from "./CanalCobroCombobox.vue?vue&type=template&id=0832b01f&scoped=true"
import script from "./CanalCobroCombobox.vue?vue&type=script&lang=js"
export * from "./CanalCobroCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0832b01f",
  null
  
)

export default component.exports